import React, {useContext} from "react";
import {Link} from 'react-router-dom';
import {css} from "emotion";
import {boxStyles, colors, textSizes} from "../../styles/theme";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import isPlanHighEnough from "../../utils/isPlanHighEnough";
import {GlobalContext} from "../../context/GlobalState";
import getPlanName from "../../utils/getPlanName";
import PaywallLink from "./PaywallLink";

const TargetingTypeItem = ({item, lastLocation}) => {
  const {currentWorkspace} = useContext(GlobalContext);
  const planName = getPlanName(currentWorkspace);
  const canAccess = isPlanHighEnough(planName, item.planNeeded);

  return (
    <>
      {canAccess ? (
        <Link to={`${item.route}?lastLocation=${lastLocation}`} className={container}>
          <div className="box">
            <div className="info">
              <h3>{item.title}</h3>
              <p>{item.subtitle}</p>
            </div>
          </div>
          <FontAwesomeIcon className="chevron" icon="chevron-right"/>
        </Link>
      ) : (
        <PaywallLink planNeeded={item.planNeeded} title={item.title} subtitle={item.subtitle} style={container}/>
      )}
    </>
  );
};

export default TargetingTypeItem;

const container = css`
  cursor: pointer;
  padding: ${boxStyles.standardPadding};
  border-bottom: 1px solid ${colors.lineBreak};
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;

  .box {
    display: flex;
    align-items: center;

    img {
      font-size: 20px;
      color: ${colors.brandColor};
      padding-right: 5px;
      width: 25px;
    }

    .info {
      padding: 0 ${boxStyles.standardPadding};
      
      h3 {
        color: ${colors.titleColor};
        font-size: ${textSizes.subtitle};
        padding-bottom: 4px;
      }
      
      p {
        color: ${colors.subtitleColor};
        font-size: ${textSizes.intermediate};
      }
    }
  }

  .chevron {
    color: ${colors.placeholderText};
  }
  .tier {
    padding: 4px 8px;
    border-radius: 40px;
    text-transform: uppercase;
    color: white;
    font-size: ${textSizes.normal};
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    padding: ${boxStyles.standardPadding} 30px;
  }
`;
